import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/contexts';
import { ConversationModel } from '~/models';
import { BulkPaneShell } from '../conversation/BulkPaneShell';
import { useBulkAgentPane } from '../conversation/useBulkAgentPane';
export const GetBulkDraftAgentPaneTID = (parentTestId)=>getTestIds(parentTestId);
export const BulkDraftAgentPane = (param)=>{
    let { scope, draftNames, onFilterUpdate, onSelectionUpdate, onScopeRestore, onDraftsChanged, onAssistantMessage, isOpen: controlledIsOpen, onOpenChange, testId = '' } = param;
    const { BulkDraftAgentPaneTestIds } = useMemo(()=>GetBulkDraftAgentPaneTID(testId), [
        testId
    ]);
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const isControlled = controlledIsOpen != null;
    const isOpen = isControlled ? controlledIsOpen : internalIsOpen;
    const setIsOpen = (open)=>{
        if (!isControlled) setInternalIsOpen(open);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
    };
    const { api: storeApi } = useStoreActions();
    const { conversation, handlers, sendPrompt } = useBulkAgentPane({
        api: {
            get: (conversationId)=>storeApi.agenticBulkDraft.get(conversationId),
            sendMessage: (args)=>storeApi.agenticBulkDraft.sendMessage(_object_spread_props(_object_spread({}, args), {
                    scope
                })),
            undo: (args)=>storeApi.agenticBulkDraft.undo(args)
        },
        createConversation: ()=>storeApi.agenticBulkDraft.create({
                matchedDraftCount: scope.matchedDraftCount,
                draftNames,
                selectedDraftIds: scope.selectedDraftIds,
                currentFilter: scope.currentFilter
            }),
        restoreMostRecent: ()=>storeApi.agenticBulkDraft.recent(),
        onScopeRestored: (restoredScope)=>onScopeRestore === null || onScopeRestore === void 0 ? void 0 : onScopeRestore(restoredScope),
        sendFeedback: (args)=>storeApi.agenticBulkDraft.feedback(args),
        onAssistantMessage: handleAssistantMessage,
        onHydrated: applyPersistedUpdates,
        onEntityApplied: (draftId)=>onDraftsChanged === null || onDraftsChanged === void 0 ? void 0 : onDraftsChanged([
                draftId
            ]),
        isOpen,
        feedbackToastTestId: BulkDraftAgentPaneTestIds.FeedbackSuccessToast()
    });
    function applyPersistedUpdates(messages) {
        const restored = ConversationModel.ofMessages(messages);
        const filterUpdate = restored.latestPersistedFilterUpdate();
        if (filterUpdate != null) onFilterUpdate === null || onFilterUpdate === void 0 ? void 0 : onFilterUpdate(filterUpdate);
        const selectionUpdate = restored.latestPersistedSelectionUpdate();
        if (selectionUpdate != null && selectionUpdate.length > 0) onSelectionUpdate === null || onSelectionUpdate === void 0 ? void 0 : onSelectionUpdate(selectionUpdate);
    }
    function handleAssistantMessage(message) {
        const content = message.assistantContent();
        if (content == null) return;
        const filterUpdate = message.persistedFilterUpdate();
        switch(content.type){
            case 'bulk-confirmation':
            case 'chat-text':
            case 'sequenced-confirmation':
                if (filterUpdate != null) onFilterUpdate === null || onFilterUpdate === void 0 ? void 0 : onFilterUpdate(filterUpdate);
                if (content.selectionUpdate != null && content.selectionUpdate.length > 0) {
                    onSelectionUpdate === null || onSelectionUpdate === void 0 ? void 0 : onSelectionUpdate(content.selectionUpdate);
                }
                break;
            case 'bulk-applied':
                onDraftsChanged === null || onDraftsChanged === void 0 ? void 0 : onDraftsChanged(content.appliedIds);
                break;
            case 'reverted':
                onDraftsChanged === null || onDraftsChanged === void 0 ? void 0 : onDraftsChanged(content.revertedItemIds);
                break;
        }
        onAssistantMessage === null || onAssistantMessage === void 0 ? void 0 : onAssistantMessage(message);
    }
    return /*#__PURE__*/ _jsx(BulkPaneShell, {
        testId: BulkDraftAgentPaneTestIds.OpenPaneHeader(),
        isOpen: isOpen,
        conversation: conversation,
        handlers: handlers,
        onSubmitPrompt: sendPrompt,
        clearChatBiName: "clear_bulk_agent_chat",
        toggleBiName: "toggle_bulk_agent_pane",
        onToggle: ()=>setIsOpen(!isOpen),
        onExpand: ()=>setIsOpen(true)
    });
};
